import CourseIcon from "@svg/header/course";
import ApplePodcast from "@svg/new-design/apple-podcast";
import Headphone from "@svg/new-design/headphone";
import MedalIcon from "@svg/new-design/medal";
import QuestionMarkCircle from "@svg/new-design/question-mark-circle";
import WebPageEyeHide from "@svg/new-design/web-page-eye-hide";
import ReelsIcon from "@svg/reels-icon";
import classNames from "classnames";
import { FC } from "react";
import { CARD_TAG } from "./types";

export const badge = {
  [CARD_TAG.VIDEO]: {
    icon: (
      <ReelsIcon className="text-fds-on-accent-light sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ),
    title: "آموزش کوتاه",
    color: "text-fds-on-accent-light",
    background: "bg-fds-accent-light",
  },
  [CARD_TAG.AUDIOBOOK]: {
    icon: <Headphone className="fill-fds-on-success-light" />,
    title: "کتاب صوتی",
    color: "text-fds-on-success-light",
    background: "bg-fds-success-light",
  },
  [CARD_TAG.BLIND]: {
    icon: (
      <WebPageEyeHide className="fill-fds-on-success-light sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ),
    title: "ویژه نابینایان",
    color: "text-fds-on-success-light",
    background: "bg-fds-success-light",
  },
  [CARD_TAG.COURSE]: {
    icon: (
      <WebPageEyeHide className="fill-icon-fds-on-brand-light sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ), ///check svg
    title: "ویدئو | زیرنویس",
    color: "text-fds-on-brand-light",
    background: "bg-fds-brand-light",
  },
  [CARD_TAG.EXAM]: {
    icon: (
      <QuestionMarkCircle className="fill-fds-on-danger-light sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ),
    title: "آزمون",
    color: "text-fds-on-danger-light",
    background: "bg-fds-danger-light",
  },
  [CARD_TAG.PACK]: {
    icon: (
      <QuestionMarkCircle className="fill-fds-on-warning-light sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ), ///check svg
    title: "گنجینه",
    color: "text-fds-on-warning-light",
    background: "bg-fds-warning-light",
  },
  [CARD_TAG.PODCAST]: {
    icon: (
      <ApplePodcast className="fill-fds-primary sm:h-3.5 h-3 sm:w-3.5 w-3" />
    ), ///check svg
    title: "پادکست",
    color: "text-fds-primary",
    background: "bg-fds-secondary",
  },
  [CARD_TAG.TEXT]: {
    icon: <CourseIcon className="fill-fds-primary sm:h-3.5 h-3 sm:w-3.5 w-3" />, ///check svg
    title: "متنی",
    color: "text-fds-primary",
    background: "bg-fds-secondary",
  },
  [CARD_TAG.CERTIFICATE]: {
    icon: <MedalIcon className="text-fds-brand sm:h-3.5 h-3 sm:w-3.5 w-3" />, ///check svg
    title: "گواهینامه",
    color: "text-fds-brand",
    background: "bg-fds-brand-light",
  },
};

interface Props {
  type: CARD_TAG;
}

const CourseTag: FC<Props> = ({ type }) => {
  return (
    <div
      className={classNames(
        "p-1 flex gap-1 rounded-full items-center h-4 sm:h-5 w-fit ",
        badge[type as CARD_TAG].background
      )}
    >
      {badge[type as CARD_TAG].icon}
      <p className={classNames("body-xxsm ", badge[type as CARD_TAG].color)}>
        {badge[type as CARD_TAG].title}
      </p>
    </div>
  );
};
export default CourseTag;
